import type { ApiListRequest, ApiListResponseV3 } from "../@types/services/Api";
import type {
  Notification,
  NotificationsFilter,
} from "../@types/services/Notification";
import { api } from "./api";

const API_BASE_URL = "/api/v3/notifications";

export type NotificationApiListResponseV3 = ApiListResponseV3<Notification> & {
  types_available: string[];
};

export const fetchNotifications = async ({
  filters,
  ...rest
}: ApiListRequest<NotificationsFilter> = {}): Promise<NotificationApiListResponseV3> => {
  const response = await api.get<NotificationApiListResponseV3>("", {
    baseURL: API_BASE_URL,
    params: {
      ...filters,
      ...rest,
    },
  });
  return response.data;
};

export const deleteNotification = async (
  notificationId: string,
): Promise<void> => {
  const response = await api.delete<void>(`/${notificationId}`, {
    baseURL: API_BASE_URL,
  });
  return response.data;
};

export const markAsReadAndSeenNotification = async (
  notificationId: string,
): Promise<Notification> => {
  const response = await api.patch<Notification>(
    `/${notificationId}/read_and_seen`,
    {},
    { baseURL: API_BASE_URL },
  );
  return response.data;
};

export const markAsReadNotification = async (
  notificationId: string,
): Promise<Notification> => {
  const response = await api.patch<Notification>(
    `/${notificationId}/read`,
    {},
    { baseURL: API_BASE_URL },
  );
  return response.data;
};

export const markAsSeenNotification = async (
  notificationId: string,
): Promise<Notification> => {
  const response = await api.patch<Notification>(
    `/${notificationId}/seen`,
    {},
    { baseURL: API_BASE_URL },
  );
  return response.data;
};

export const markAsUnreadAndUnseenNotification = async (
  notificationId: string,
): Promise<Notification> => {
  const response = await api.patch<Notification>(
    `/${notificationId}/unread_and_unseen`,
    {},
    { baseURL: API_BASE_URL },
  );
  return response.data;
};

export const markAsUnreadNotification = async (
  notificationId: string,
): Promise<Notification> => {
  const response = await api.patch<Notification>(
    `/${notificationId}/unread`,
    {},
    { baseURL: API_BASE_URL },
  );
  return response.data;
};

export const markAsUnseenNotification = async (
  notificationId: string,
): Promise<Notification> => {
  const response = await api.patch<Notification>(
    `/${notificationId}/unseen`,
    {},
    { baseURL: API_BASE_URL },
  );
  return response.data;
};

export const fetchUnreadNotificationCounts = async (): Promise<{
  total_unread: number;
  unread_by_type: Record<string, number>;
}> => {
  const response = await api.get("/unread_counts", {
    baseURL: API_BASE_URL,
  });
  return response.data;
};
